"use client";

import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import customerCartSlice from "./features/customerCartSlice";
import mapReducer from "./features/mapSlice";
import paHatidReducer from "./features/paHatidSlice";
import searchReducer from "./features/searchSlice";

// Create a combined reducer

const rootReducer = combineReducers({
  customerCart: customerCartSlice,
  paHatid: paHatidReducer,
  map: mapReducer,
  search: searchReducer,
});

const persistConfig = {
  key: "root",
  storage, //localStorage, defines storage method
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the store with the persisted reducer
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializableCheck for redux-persist
    }),
});

export const persistor = persistStore(store);

export default store;
